import { render, staticRenderFns } from "./PublishedBuyingTendersList.vue?vue&type=template&id=32def2ca&"
import script from "./PublishedBuyingTendersList.vue?vue&type=script&lang=ts&"
export * from "./PublishedBuyingTendersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports